import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import SVG from '@/plugins/svg'
import Message from '@/plugins/message'
import ElementUI from '@/plugins/elementUi'
import 'normalize.css/normalize.css'
import '@/styles/theme/index.css'
import '@/styles/style.scss'

Vue.config.productionTip = false
Vue.use(ElementUI, 'index')
Vue.use(SVG)
Vue.use(Message)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#main-app')
